import { Star, ArrowUpRight } from "lucide-react";
import { MaskedLine, FadeUp } from "./Reveal";
import { BUSINESS, GOOGLE_REVIEWS } from "@/data/content";

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="border-t-2 border-terra bg-ink py-12 text-paper lg:py-28">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-6 lg:grid-cols-12 lg:gap-16 lg:px-12">
        <div className="lg:col-span-5">
          <FadeUp>
            <p className="mb-10 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.35em] text-paper/50">
              <span className="inline-block h-2 w-2 bg-clay" />
              Reputation
            </p>
          </FadeUp>
          <FadeUp delay={0.1}>
            <div className="flex items-end gap-6">
              <span data-testid="rating-value" className="font-serif text-8xl leading-none tracking-tighter lg:text-9xl">
                {BUSINESS.rating}
              </span>
              <div className="pb-3">
                <div className="mb-2 flex gap-1 text-clay">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={18} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <p className="text-xs uppercase tracking-[0.25em] text-paper/60">out of 5 on Google</p>
              </div>
            </div>
          </FadeUp>
        </div>
        <div className="flex flex-col justify-center lg:col-span-6 lg:col-start-7">
          <h2 className="font-serif text-3xl leading-[1.15] tracking-tighter sm:text-4xl lg:text-5xl">
            <MaskedLine>{BUSINESS.reviewCount} Google reviews —</MaskedLine>
            <MaskedLine delay={0.12}>
              <em className="text-clay">and counting.</em>
            </MaskedLine>
          </h2>
          <FadeUp delay={0.2}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-paper/60">
              Real feedback from real projects across Greater Noida. Read what
              customers say about designing and building with us.
            </p>
            <a
              href={BUSINESS.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-link"
              className="group mt-10 inline-flex w-fit items-center gap-3 border border-paper/30 px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] transition-colors duration-300 hover:border-clay hover:bg-clay hover:text-ink"
            >
              Read our reviews on Google
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </FadeUp>
        </div>
      </div>
      <div
        data-testid="review-cards"
        className="mx-auto mt-10 grid max-w-[1400px] grid-cols-1 gap-6 px-6 md:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:px-12"
      >
        {GOOGLE_REVIEWS.map((r, i) => (
          <FadeUp key={r.name} delay={i * 0.1} className="h-full">
            <blockquote
              data-testid={`review-card-${i + 1}`}
              className="flex h-full flex-col border border-paper/15 p-6 transition-colors duration-500 hover:border-clay/60 lg:p-8"
            >
              <span className="font-serif text-5xl leading-none text-clay">&ldquo;</span>
              <p className="mt-4 flex-1 font-serif text-lg italic leading-relaxed text-paper/85">
                {r.text}
              </p>
              <footer className="mt-8 flex items-center justify-between gap-4 border-t border-paper/15 pt-5">
                <div>
                  <p className="text-sm font-semibold tracking-wide">{r.name}</p>
                  <p className="mt-1 text-[10px] uppercase tracking-[0.25em] text-paper/50">
                    {r.meta}
                  </p>
                </div>
                <div className="flex shrink-0 gap-0.5 text-clay">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={12} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
              </footer>
            </blockquote>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
